<template>
  <q-btn class="runai-btn" :aid="aid" :="$attrs" @click.stop :disable="disabled">
    <slot></slot>
    <q-tooltip v-if="showInfoTooltip">{{ tooltip }}</q-tooltip>
  </q-btn>
  <q-tooltip :target="`.runai-btn[aid='${aid}']`" v-if="$attrs.disable && disabledTooltip">
    {{ disabledTooltip }}
  </q-tooltip>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
export default defineComponent({
  name: "runai-btn",
  props: {
    aid: {
      type: String,
      required: true,
    },
    disabledTooltip: {
      type: String as PropType<string>,
      required: false,
    },
    tooltip: {
      type: String as PropType<string>,
      required: false,
    },
  },
  computed: {
    disabled(): boolean {
      return !!this.$attrs.disable || !!this.$attrs.loading;
    },
    showInfoTooltip(): boolean {
      // Showing the information tooltip only if the button is not disabled and got no disabled tooltip
      // to avoid multiple tooltips at the same time
      return !!this.tooltip && !this.$attrs.disable && !this.disabledTooltip;
    },
  },
});
</script>
